import React from "react"
import QRCode from "qrcode.react"
import "./ClientSticker.scss"
import sticker_by from "./images/Sticker_A5_USERS.svg"
import sticker_ru from "./images/Sticker_A5_USERS.svg"
import sticker_am from "./images/Sticker_A5_USERS_AM.svg"
import sticker_lt_lt from "./images/Sticker_A5_USERS_LT.svg"
import sticker_lt_en from "./images/Sticker_A5_USERS_LT_EN.svg"
import sticker_cy_en from "./images/Sticker_A5_USERS_CY_EN.svg"
import { useTranslation } from "react-i18next"
import { checkIsAllsports } from "../../../domain_utils"
import { CLIENT_INSTRUCTION_STICKERS_LANGUAGE } from "../../../locales"

function ClientSticker({ language }) {
  const { t } = useTranslation()
  const stickers = {
    sticker_by,
    sticker_ru,
    sticker_am,
    sticker_lt_lt,
    sticker_lt_en,
    sticker_cy_en,
  }

  const sticker = stickers[`sticker_${language}`]

  const enableDynamicQrCode =
    language === CLIENT_INSTRUCTION_STICKERS_LANGUAGE.by || language === CLIENT_INSTRUCTION_STICKERS_LANGUAGE.lt_lt ||
    language === CLIENT_INSTRUCTION_STICKERS_LANGUAGE.ru

  const qrCode = checkIsAllsports(language)
    ? "c83f4655b8f84f949b872aeaba530576"
    : "https://h.sportbenefit.eu/s/c9e8"
  return (
    <section className="client-sticker">
      <div className="title">{t("app.client.sticker.title")}</div>
      <div className="sheet printing-block">
        <img
          src={sticker}
          alt={t("app.client.sticker.instruction_alt")}
        />
        {enableDynamicQrCode && (
          <div>
            <QRCode value={qrCode} className="qrcode" size="256" />
            <div className="supplier_name">
              {t("app.client.sticker.test_supplier")}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default ClientSticker
